import LinkGroup from './LinkGroup';

const LOW_PRIORITY = 500;

/**
 * Custom properties provider that adds an "Externe Links" group
 * to the properties panel for Process, Task, and SubProcess elements.
 */
export default class LinkPropertiesProvider {
  constructor(propertiesPanel, injector) {
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
    this._injector = injector;
  }

  getGroups(element) {
    return (groups) => {
      const linkGroup = LinkGroup(element, this._injector);

      if (linkGroup) {
        groups.push(linkGroup);
      }

      return groups;
    };
  }
}

LinkPropertiesProvider.$inject = ['propertiesPanel', 'injector'];
